import { intlShape } from "../../shapes";
import { withIntl } from "../../wrappers";
import DynamicFieldArray from "../Form/DynamicFieldArray";
import WarningBox from "../WarningBox";
import SpecificationKeyTypeahead from "./SpecificationKeyTypeahead";
import SpecificationVisibilityToggle from "./SpecificationVisibilityToggle";

type ISpecificationsInputProps = {
  readonly specificationKeysEndpoint: string;
  readonly intl: intlShape;
  readonly disabled?: boolean;
  readonly isSubmitting?: boolean;
  readonly isUserProjectEngineer?: boolean;
};

export function SpecificationsInput(props: ISpecificationsInputProps) {
  const { intl, disabled, isSubmitting, isUserProjectEngineer = false } = props;

  const fieldNames = isUserProjectEngineer
    ? ["uiVisible", "key", "value"]
    : ["key", "value"];
  const colSizeArray = isUserProjectEngineer ? [2, 4, 4] : [5, 5];
  const fieldComponents = isUserProjectEngineer
    ? [SpecificationVisibilityToggle, SpecificationKeyTypeahead]
    : [SpecificationKeyTypeahead];

  return (
    <>
      <label htmlFor="specifications" data-testid="specifications-input">
        {intl.formatMessage({ id: "specifications.title" })}
      </label>
      <DynamicFieldArray
        {...props}
        valueArrayName="specifications"
        placeholders={[
          intl.formatMessage({ id: "specifications.label" }),
          intl.formatMessage({ id: "specifications.value" }),
        ]}
        fieldNames={fieldNames}
        colSizeArray={colSizeArray}
        fieldComponents={fieldComponents}
        disabled={disabled || isSubmitting}
      />
      {isUserProjectEngineer && (
        <WarningBox
          id="warning-visibility-control"
          title={intl.formatMessage({ id: "warning-visibility-control_title" })}
          message={intl.formatMessage({
            id: "warning-visibility-control_message",
          })}
          type="info"
        />
      )}
    </>
  );
}

export default withIntl(SpecificationsInput);
